import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { IconsModule } from '../../design/icons.module';
import { TableExportButtonComponent } from './table-export-button.component';
import { TableExportDirective } from './table-export.directive';

@NgModule({
  declarations: [TableExportButtonComponent, TableExportDirective],
  imports: [CommonModule, IconsModule],
  exports: [TableExportDirective]
})
export class TableExportModule { }
